import { CommonModule, registerLocaleData } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import localeEs from '@angular/common/locales/es';
import { NgModule, inject } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { HttpInterceptorProviders } from './interceptors/http-interceptors-provider';

@NgModule({
  declarations: [],
  imports: [CommonModule, MatSnackBarModule],
  providers: [
    HttpInterceptorProviders,
    { provide: Window, useValue: window },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CoreModule {
  constructor() {
    const parentModule = inject(CoreModule, { optional: true, skipSelf: true });

    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import only in AppModule');
    }
  }
}

registerLocaleData(localeEs, 'es-ES');
